module.exports = __webpack_public_path__ + "img/js5.4287b1fc.jpg";